/* MYNTELO scroll reveals (2026-10-08). Tags known blocks with data-reveal, staggers siblings with --i, reveals each once when it enters view.
   Styles in assets/myntelo-layout.css. Off for prefers-reduced-motion, the theme editor and browsers without IntersectionObserver. */
(function(){
  if(!('IntersectionObserver' in window)) return;
  if(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if(window.Shopify && Shopify.designMode) return;
  var G=[
    ['.m-remix__heading h2, .m-section-heading h2, .m-proof__head h2, .m-atmosphere__heading h2, .m-faq__intro h2, .m-feeling h2','mask'],
    ['.m-section-heading .m-link, .m-proof__lede, .m-proof__tag, .m-atmosphere__intro, .m-atmosphere__invitation, .m-faq__intro p, .m-feeling__text p, .m-feeling__text .m-button','up'],
    ['.m-remix__shell','rise'],
    ['.m-product-grid > .m-card','up',1],
    ['.m-trust--strip > li','up',1],
    ['.m-proof__promises > li','up',1],
    ['.m-proof__posts > li, .m-proof__reviews > *','up',1],
    ['.m-feeling__art','scale'],
    ['.m-process > *','up',1],
    ['.m-faq details','up',1],
    ['.m-remix-legal','up']
  ];
  var els=[];
  G.forEach(function(g){
    var list=[].slice.call(document.querySelectorAll(g[0])), seen=new Map();
    list.forEach(function(el){
      if(el.hasAttribute('data-reveal') || el.closest('.m-header, .m-brand, [data-reveal]')) return;
      el.setAttribute('data-reveal', g[1]);
      if(g[2]){ var p=el.parentNode, n=seen.get(p)||0; el.style.setProperty('--i', Math.min(n,6)); seen.set(p,n+1); }
      els.push(el);
    });
  });
  if(!els.length) return;
  var map=new Map();
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(!e.isIntersecting) return; (map.get(e.target)||[]).forEach(function(el){ el.classList.add('is-in'); }); map.delete(e.target); io.unobserve(e.target); });
  },{rootMargin:'0px 0px -8% 0px',threshold:0.01});
  els.forEach(function(el){
    var r=el.getBoundingClientRect();
    if(r.bottom<0){ el.classList.add('is-in'); return; }   // already scrolled past (anchor links, back button)
    // Mask headings (clipped, never report as intersecting) and cards inside sideways carousels (off-screen until swiped) are watched through their parent.
    var pe=el.parentElement, side=pe && pe.scrollWidth>pe.clientWidth+4 && /auto|scroll/.test(getComputedStyle(pe).overflowX);
    var t=(el.getAttribute('data-reveal')==='mask' || side) ? (pe||el) : el;
    if(!map.has(t)){ map.set(t,[]); io.observe(t); }
    map.get(t).push(el);
  });
  document.documentElement.classList.add('mx-reveal');
  // Safety net: anything still hidden after a hash jump or bfcache restore is shown.
  addEventListener('pageshow', function(ev){ if(ev.persisted) els.forEach(function(el){ el.classList.add('is-in'); }); });
})();
